import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { ContractForm, ContractFormData } from './ContractForm';
import { CreateContractDto } from '@/lib/api/contracts';

export interface CreateContractModalProps extends BaseModalProps {
  onCreate: (data: CreateContractDto) => Promise<boolean>;
  isCreating: boolean;
}

export function CreateContractModal({
  open,
  onOpenChange,
  onCreate,
  isCreating,
}: CreateContractModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: ContractFormData) => {
    const success = await onCreate({
      companyName: data.companyName,
      contractNumber: data.contractNumber,
      startDate: data.startDate,
      endDate: data.endDate,
      contractedHours: data.contractedHours,
      monthlyHoursLimit: data.monthlyHoursLimit,
      minDebitTime: data.minDebitTime,
      accumulateHours: data.accumulateHours,
      excludeProactiveTickets: data.excludeProactiveTickets,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('contracts.createModal.title')}>
      <ContractForm
        mode="create"
        onSubmit={handleSubmit}
        isLoading={isCreating}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
